import { filterProps, motion } from 'framer-motion';
import { useState, useMemo, useEffect, useCallback } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { Carousel } from '@mantine/carousel';
import CardDekstopCompo from '../components/cardDekstop/carddekstop-component';
import CardMobileCompo from '../components/cardMobile/cardmobile-component';
import CarouselCompo from '../components/carousel/carousel-component';
import CarouselCompo2 from '../components/carousel2/carousel2-component';
import InfoCardCompo from '../components/infoCard/infocard-component';
import JumboTron2 from '../components/jumbotron-2/jumbotron2-component';
import style from '../styles/housingPageStyle.module.css';
import lokasiPerumStyle from '../components/lokasiPerumahan/lokasiPerumCompoStyle.module.css';
import LokasiPerumCompo from '../components/lokasiPerumahan/lokasiperumahan-component';
import { createStyles, Image } from '@mantine/core';
import Breadcrumbs2Component from '../components/breadcrumbs/breadcrumbs2-component';
import { FooterCompo } from '../components';
import DescriptionHousingComponent from '../components/DescriptionHouse/descriptionhousing-component';
import DescHouseCompo from '../components/DescriptionHouse/descriptionhouse-component';
import capitalizeWord from '../utility/capitalizeWord';
import { createRoot } from 'react-dom/client';
import { ReactSVG } from 'react-svg';

const useStyle = createStyles((theme) => ({
  root: {
    '@media (max-width: 600px)': {
      paddingLeft: 30,
      gap: 10,
    },
  },
  control: {
    backgroundColor: '#F2EEC8',
    color: '#F56600',
    borderColor: '#F2EEC8',
    opacity: 1,
  },
}));

const HousingPage = (props) => {
  const [property, setProperty] = useState(null);
  const [otherproperties, setOtherproperties] = useState();
  const [fetching, setFetching] = useState(false);

  const { classes } = useStyle();
  const [searchParams, setSearchParams] = useSearchParams();

  async function fetchDetailProperty(id) {
    await fetch(`${process.env.REACT_APP_URL}/property/${id}`)
      .then(async (res) => {
        return await res.json();
      })
      .then((res) => {
        const element = res.data;
        console.log(element);
        setProperty(element);
      });
  }
  async function fetchotherProperties(city, transaction, categories, name) {
    await fetch(
      `${process.env.REACT_APP_URL}/properties?city=${city}&transaction=${transaction}&categories=${categories}&name=${name}`
    )
      .then(async (res) => {
        return await res.json();
      })
      .then((res) => {
        const element = [];
        for (let i = 0; i < res.data.length; i++) {
          element.push(res.data[i]);
        }
        console.log(element);
        setOtherproperties(element);
      });
  }

  const fetchAPI = useCallback(
    async (id) => {
      if (!property && id) {
        await fetchDetailProperty(id);
      }

      await fetchotherProperties(
        property?.address.lower_city,
        property?.transaction,
        property?.categories.map((e) => e.name),
        property?.name
      );
    },
    [property, fetchotherProperties]
  );

  console.log(property && !otherproperties, otherproperties);

  useEffect(() => {
    const id = searchParams.get('id');

    if (!fetching) {
      fetchAPI(id).then((value) => setFetching(true));
    }
  }, [fetchAPI, fetching, searchParams]);

  return (
    <motion.div
      initial={{ width: 0 }}
      animate={{ width: '100%' }}
      exit={{ x: window.innerWidth, transition: { duration: 1 } }}
    >
      {/* {breadcrumbs.map((item, key) => {
        return <BreadCrumbCompo key={key} items={item.title} />;
      })} */}
      {/* <Breadcrumbs2Component /> */}
      <Breadcrumbs2Component />
      {fetching && property?.id && <CarouselCompo property={property} />}
      {fetching && property?.id && (
        <main>
          <div className={`${style['container-fluid']} mb-0`}>
            <div className={`row ${style.rows}`}>
              <div
                className={`col-12 col-md-6 col-lg-5 p-0 ${style.pembungkus1}`}
              >
                <div className={style.row}>
                  <div className="col d-flex flex-column">
                    <div className={style.header}>
                      <div className={`p-0 m-0 ${style['rincian-1']}`}>
                        {property?.address && (
                          <DescriptionHousingComponent
                            key={property.id}
                            title={property.name}
                            address={`${property.address.street}, ${
                              property.address.lower_city[0].toUpperCase() +
                              property.address.lower_city.substring(1)
                            }`}
                            categories={property.categories.map((e) => e.name)}
                            transaction={property.transaction}
                          />
                        )}
                      </div>
                      <div className={style['rincian-2']}>
                        <h1>Detail</h1>
                        <div className={`${style.rowRincian2} row`}>
                          <div className="col p-0">
                            <h3>Pengembang</h3>
                            <p>{property.developer}</p>
                            <h3>Pembayaran</h3>
                            {property.payments?.map((payment, key) => (
                              <p key={key}>{payment}</p>
                            ))}
                          </div>
                          <div className="col p-0">
                            <h3>Tipe Properti</h3>
                            <p>{capitalizeWord(property.property_type)}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={`${style.tombol} ${style.item1}`}>
                      {property.brochure && (
                        <span className={style.spanTombol1}>
                          <img
                            src={require('../assets/images/Button-icon-Brosur.png')}
                            alt=""
                            width="15%"
                          />
                          <button
                            type="button"
                            className="btn btn-success rounded-pill"
                          >
                            <p className="m-0">Brosur</p>
                          </button>
                        </span>
                      )}
                      {property.panoramas?.length > 0 && (
                        <span className={style.spanTombol2}>
                          <img
                            src={require('../assets/images/Button-icon-3D.png')}
                            alt=""
                            width="17%"
                          />
                          <button
                            type="button"
                            className="btn btn-success rounded-pill"
                          >
                            <p className="m-0">360 View</p>
                          </button>
                        </span>
                      )}
                    </div>
                    <div
                      className={`${style['rincian-3']} ${style.item2} ${style.deskripsi}`}
                    >
                      {property.description && (
                        <DescHouseCompo
                          key={property.id}
                          description1={property.description}
                        />
                      )}
                    </div>
                    {property.type_houses?.length > 0 && (
                      <div
                        className={`${style['rincian-4']} ${style.item3} ${style.tpRumah}`}
                      >
                        <h1>Tipe Rumah</h1>
                        {/* <!-- For Dekstop--> */}
                        <div className={style.carouselContainerDekstop}>
                          <Carousel
                            controlsOffset="10%"
                            controlSize={40}
                            align="start"
                            height={400}
                            slideSize="10%"
                            classNames={{ control: classes.control }}
                            styles={{
                              control: {
                                '&[data-inactive]': {
                                  opacity: 0.5,
                                  cursor: 'default',
                                },
                              },
                            }}
                          >
                            {property?.type_houses &&
                              property?.type_houses?.map((item, key) => {
                                return (
                                  <a
                                  href="ttps://play.google.com/store/apps/details?id=id.asc.sepakat"
                                  target="_blank"
                                  rel="noreferrer"
                                    // to={`/detail-tipe?id=${item.id}&property_id=${property.id}`}
                                      key={key}
                                  >
                                    <CardDekstopCompo
                                      image={item.images[0]}
                                      title={item.name}
                                      address={item.property_type}
                                    />
                                  </a>
                                );
                              })}
                          </Carousel>
                        </div>
                        {/* <!-- End Dekstop --> */}

                        {/* <!-- For Mobile --> */}
                        <div className={style.carouselContainerMobile}>
                          {property?.type_houses &&
                            property?.type_houses?.map((item, key) => {
                              return (
                                <CardMobileCompo
                                  key={key}
                                  image={item.images[0]}
                                  title={item.name}
                                  address={item.property_type}
                                />
                              );
                            })}
                        </div>
                        {/* <!-- End For Mobile --> */}
                      </div>
                    )}
                    <InfoCardCompo />
                  </div>
                </div>
              </div>
              <div
                className={`col-12 col-md-6 col-lg-4 p-0 ${style.item4} ${style.sitePlan} ${style.pembungkus2}`}
              >
                {property.siteplan && (
                  <>
                    <h1>Siteplan</h1>
                    <div className={style.btnWrapper}>
                      <div className={style.containerStackImage}>
                        {property.siteplan?.background && (
                          <img
                            src={property.siteplan.background}
                            alt=""
                            className={`mb-3 ${style.sitePlanImg}`}
                          />
                        )}
                      </div>
                      <div className={style.stackImage}>
                        {property.siteplan?.image && (
                          <ReactSVG
                            aria-label="Description of the overall image"
                            beforeInjection={(error, svg) => {
                              if (error) {
                                console.error(error)
                                return
                              }
                              console.log(svg)
                              // const desc = document.createElementNS(
                              //   'http://www.w3.org/2000/svg',
                              //   'desc'
                              // );
                              // desc.innerHTML = 'A description';
                              // svg.prepend(desc);

                              // const title = document.createElementNS(
                              //   'http://www.w3.org/2000/svg',
                              //   'title'
                              // );
                              // title.innerHTML = 'A title';
                              // svg.prepend(title);
                            }}
                            role="img"
                            evalScripts="always"
                            fallback={() => <span>Error!</span>}
                            httpRequestWithCredentials={true}
                            loading={() => <span>Loading</span>}
                            onClick={() => {
                              console.log('wrapper onClick')
                            }}
                            renumerateIRIElements={false}
                            src="svg.svg"
                            useRequestCache={false}
                            wrapper="span"
                          />
                        )}
                        {/* <Image
                            src={property.siteplan.image}
                            className={`mb-3 ${style.sitePlanImg}`}
                          /> */}
                      </div>
                      <a href="https://play.google.com/store/apps/details?id=id.asc.sepakat" target="_blank" rel="noreferrer">
                      <button
                        type="button"
                        className={`btn btn-success rounded-pill ${style.tombolSitePlan}`}
                      >
                        <p className="m-0">Buka Siteplan</p>
                      </button>
                      </a>
                    </div>
                  </>
                )}
                {property.sketch && (
                  <>
                    <h1>Sketch</h1>
                    <div className={style.btnWrapper}>
                      {property.sketch && (
                        <img
                          src={property.sketch}
                          alt=""
                          className={`mb-3 ${style.sitePlanImg}`}
                        />
                      )}
                      <button
                        type="button"
                        className={`btn btn-success rounded-pill ${style.tombolSitePlan}`}
                      >
                        <p className="m-0">Buka Siteplan</p>
                      </button>
                    </div>
                  </>
                )}
                <h1>Lokasi Perumahan</h1>
                <div
                  className={`${lokasiPerumStyle.lokasiPerumahan} p-3 rounded-4 shadow-lg mb-5 bg-body rounded mt-4`}
                >
                  {property.near_facilities?.map((item, key) => {
                    return (
                      <LokasiPerumCompo
                        key={key}
                        icon={require('../assets/images/Card-Frame 502.png')}
                        title={item.name}
                        time={item.mileage + ' Menit'}
                      />
                    );
                  })}
                </div>
              </div>

              <div
                className={`col-12 col-md-0 col-lg-6 p-0 ${style['rincian-6']} mt-2 ${style.perumahanLn}`}
              >
                <h1>Perumahan Lainnya</h1>
              </div>
            </div>
          </div>
          <Carousel
            controlsOffset="20%"
            controlSize={40}
            slideSize={350}
            slideGap={30}
            align="start"
            pl={280}
            classNames={{
              control: classes.control,
              root: classes.root,
            }}
          >
            {otherproperties?.map((item, key) => {
              return (
                <Link to={`/properti?id=${item.id}`} 
                    key={key}>
                  <CarouselCompo2
                    image={item.images[0]}
                    title={item.name}
                    address={`${item.address.street}, ${capitalizeWord(
                      item.address.lower_city
                    )}`}
                  />
                </Link>
              );
            })}
          </Carousel>

          <div className="mt-5"></div>
          <JumboTron2 />
        </main>
      )}
      <FooterCompo />
    </motion.div>
  );
};

export default HousingPage;
